// Description: Currency utils

import currencyMapping from "./data";

export class MultiCurrency {
  static isCurrencySupported(currencyCode) {
    return currencyMapping.currencies_supported.includes(currencyCode);
  }

  static getMapping(currencyCode) {
    // console.log('getMapping.....', currencyCode);
    if (!this.isCurrencySupported(currencyCode)) {
      throw new Error("Currency not supported");
    } else {
      return currencyMapping.currency_mapping[currencyCode];
    }
  }

  static getCurrencySymbol(currencyCode) {
    // console.log('getCurrencySymbol.....', currencyCode);
    const currencyMapping = this.getMapping(currencyCode);
    return currencyMapping.symbol;
  }

  static getCurrencyLocale(currencyCode) {
    // console.log('getCurrencyLocale.....', currencyCode);
    const currencyMapping = this.getMapping(currencyCode);
    return currencyMapping.locale || "en-US";
  }

  static formatAmount(amount, currencyCode, withSymbol = false) {
    const numberAmount = Number(amount);

    const currencyLocale = this.getCurrencyLocale(currencyCode);

    // Code referrenced from https://stackoverflow.com/q/44969852/16036745
    // const currencyFractionDigits = new Intl.NumberFormat(currencyLocale, {
    //   style: "currency",
    //   currency: currencyCode,
    // }).resolvedOptions().maximumFractionDigits;

    const formatOptions = {
      style: "currency",
      currency: currencyCode,
      currencyDisplay: withSymbol ? "symbol" : "none",
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    };

    // US$9,000,000 or ₹9,00,000 orUS$1,234,567.89 or ₹12,34,567.89
    const localeAmount = numberAmount.toLocaleString(
      currencyLocale,
      formatOptions
    );

    return localeAmount;
  }

  static formatAmountWithSymbol(amount, currencyCode) {
    const localeAmount = this.formatAmount(amount, currencyCode, true);
    return localeAmount;
  }

  static formatCurrencyLabel(currencyCode) {
    const currencyMapping = this.getMapping(currencyCode);
    return `${currencyMapping.name} (${currencyCode})`;
  }

  static getMinAuthValue(currencyCode) {
    let minAuthValue;
    let denomination;

    try {
      const currencyMapping = this.getMapping(currencyCode);

      minAuthValue = currencyMapping.min_auth_value;
      denomination = currencyMapping.denomination;
    } catch (err) {
      const message = `Error ${err} trying to get currency min auth value for ${currencyCode}`;
      console.log(message);

      minAuthValue = 1;
      denomination = 1;
    }

    const minAuthValueInCurrency = minAuthValue / denomination;

    return minAuthValueInCurrency;
  }
}
